import { MapPin, Phone, Mail, Building2, Facebook, Instagram, Youtube } from "@/components/Icon";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import logoWit from "@/assets/logo-magic-print-wit.webp";

const Footer = () => (
  <footer className="bg-[#0a2933] text-white pt-16 pb-6">
    <div className="container">
      <div className="grid md:grid-cols-4 gap-12">
        <div className="space-y-4">
          <img
            src={logoWit}
            alt="Magic Print logo"
            width={268}
            height={56}
            className="h-10 w-auto object-contain"
          />
          <p className="text-sm leading-relaxed text-white">
            Dé specialist in kleding bedrukken in Den Haag. Wij bedrukken t-shirts, hoodies, sweaters, polo's en bedrijfskleding voor bedrijven, evenementen en verenigingen.
          </p>
        </div>

        <div className="space-y-4">
          <h3 className="font-heading font-semibold text-white">Contact</h3>
          <div className="flex flex-col gap-3 text-sm">
            <div className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#059594]" />
              <span>Platinaweg 25<br />2544 EZ Den Haag</span>
            </div>
            <a href="tel:+31708873306" className="flex items-center gap-2 hover:text-[#059594] transition-colors">
              <Phone className="w-4 h-4 flex-shrink-0 text-[#059594]" />
              070 887 3306
            </a>
            <a href="mailto:info@magicprint.nl" className="flex items-center gap-2 hover:text-[#059594] transition-colors">
              <Mail className="w-4 h-4 flex-shrink-0 text-[#059594]" />
              info@magicprint.nl
            </a>
            <div className="flex items-center gap-2 text-sm text-white">
              <Building2 className="w-4 h-4 text-[#059594]" />
              <span>KvK: 53342178</span>
            </div>
          </div>
          <div className="flex items-center gap-2 mt-3">
            <a
              href="https://www.facebook.com/MagicPrint070/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="w-7 h-7 rounded-full bg-[#059594] text-white flex items-center justify-center hover:bg-white hover:text-[#059594] transition-colors"
            >
              <Facebook className="w-4 h-4" />
            </a>
            <a
              href="https://www.instagram.com/magicprint070/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="w-7 h-7 rounded-full bg-[#059594] text-white flex items-center justify-center hover:bg-white hover:text-[#059594] transition-colors"
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a
              href="https://www.youtube.com/@MagicPrintDenHaag"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              className="w-7 h-7 rounded-full bg-[#059594] text-white flex items-center justify-center hover:bg-white hover:text-[#059594] transition-colors"
            >
              <Youtube className="w-4 h-4" />
            </a>
          </div>
          <div className="flex flex-col gap-2 text-sm text-white mt-4">
            <Link to="/privacy" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Privacyverklaring</Link>
            <Link to="/algemene-leveringsvoorwaarden" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Algemene leveringsvoorwaarden</Link>
            <button
              type="button"
              onClick={() => (window as any).openCookieSettings?.()}
              className="text-left flex items-center gap-1 hover:text-[#059594] transition-colors"
            >
              <ChevronRight className="w-4 h-4 text-[#059594]" /> Cookie-instellingen
            </button>
          </div>
        </div>

        <div className="space-y-4">
          <h3 className="font-heading font-semibold text-white">Diensten</h3>
          <div className="flex flex-col gap-2 text-sm">
            <Link to="/druktechnieken" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Druktechnieken</Link>
            <Link to="/druktechnieken/borduren" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Borduren</Link>
            <Link to="/druktechnieken/dtf-printing" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> DTF Printing</Link>
            <Link to="/t-shirt-bedrukken" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> T-shirt bedrukken</Link>
            <Link to="/bedrijfskleding-werkkleding" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Bedrijfskleding</Link>
            <Link to="/sportkleding-bedrukken-2" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Sportkleding</Link>
          </div>
        </div>

        <div className="space-y-4">
          <h3 className="font-heading font-semibold text-white">Links</h3>
          <div className="flex flex-col gap-2 text-sm">
            <Link to="/" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Home</Link>
            <Link to="/druktechnieken" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Druktechnieken</Link>
            <Link to="/textiel-bedrukken" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Textiel bedrukken</Link>
            <Link to="/over-ons" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Over ons</Link>
            <Link to="/aanbiedingen" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Aanbiedingen</Link>
            <Link to="/offerte-aanvragen" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Offerte aanvragen</Link>
            <Link to="/contact" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Contact</Link>
            <Link to="/blog" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Blog</Link>
          </div>
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-white/10">
        <h3 className="font-heading font-semibold text-white mb-4">Bedrukken in jouw regio</h3>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-x-12 gap-y-2 text-sm text-white">
          <Link to="/t-shirt-bedrukken-den-haag" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Den Haag</Link>
          <Link to="/t-shirt-bedrukken-in-rotterdam" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Rotterdam</Link>
          <Link to="/t-shirt-bedrukken-in-leiden" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Leiden</Link>
          <Link to="/t-shirt-bedrukken-in-delft" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Delft</Link>
          <Link to="/t-shirt-bedrukken-zoetermeer" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Zoetermeer</Link>
          <Link to="/t-shirt-bedrukken-rijswijk" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Rijswijk</Link>
          <Link to="/t-shirt-bedrukken-voorburg-magic-print-voorburg" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Voorburg</Link>
          <Link to="/t-shirt-bedrukken-leidschendam-magic-print-leidschendam" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Leidschendam</Link>
          <Link to="/shirt-bedrukken-wassenaar" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Wassenaar</Link>
          <Link to="/t-shirt-bedrukken-voorschoten-magic-print-snel-goedkoop-professioneel" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Voorschoten</Link>
          <Link to="/t-shirt-bedrukken-scheveningen-magic-print-haag" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Scheveningen</Link>
          <Link to="/tshirt-bedrukken-westland" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Westland</Link>
          <Link to="/t-shirt-bedrukken-zuid-holland" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Zuid-Holland</Link>
          <Link to="/t-shirt-bedrukken-zeeland" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Zeeland</Link>
          <Link to="/kleding-bedrukken-rotterdam" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Kleding Rotterdam</Link>
          <Link to="/borduren-den-haag" className="flex items-center gap-1 hover:text-[#059594] transition-colors"><ChevronRight className="w-4 h-4 text-[#059594]" /> Borduren Den Haag</Link>
        </div>
      </div>

      <div className="border-t border-white/10 mt-10 pt-4 text-center text-xs text-white">
        © 2026 Magic Print — Alle rechten voorbehouden
      </div>
    </div>
  </footer>
);

export default Footer;
